import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { XbrlFilingData } from 'src/app/models/xbrlFilingData.model';

/**
 * The Api Client for the ActorActionssController
 */
@Injectable({
  providedIn: 'root'
})
export class FilingDataApiClient {

  constructor(private httpClient: HttpClient) { }

  configUrl = environment.apiUrl + "/fe-api/filing-data/";

  /** GET the filing data for a request */
  async get(requestGuid: string) {
    return this.httpClient.get<XbrlFilingData>(this.configUrl + requestGuid + "", {})
  }

  /** UPDATE the filing data for a request */
  async update(requestGuid: string, filingData: XbrlFilingData) {
    return this.httpClient.post(this.configUrl + requestGuid + "", filingData);
  }
}
